module.exports = __webpack_public_path__ + "static/media/Order.e9ad67a4.svg";